import React from "react";
import classNames from "classnames";
import withStyles from "@material-ui/core/styles/withStyles";
import GridContainer from "../../components/Grid/GridContainer.jsx";
import GridItem from "../../components/Grid/GridItem.jsx";
import Parallax from "../../components/Parallax/Parallax.jsx";
import SectionServices from "./Sections/SectionServices.jsx";
import SectionContacts from "./Sections/SectionContacts.jsx";
import SectionProjects from "./Sections/SectionProjects.jsx";
import Layout from "../../Layout/Layout.jsx";

import componentsStyle from "../../assets/jss/material-kit-react/views/components.jsx";

import { withRouter } from "react-router";
import Flipp from "../../components/FlippingCard/FlippingCard.jsx";
import SectionSponsor from "./Sections/SectionSponsors.jsx";

class Components extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      language: window.language.setLanguage(props.match.params.lang).components
    };
  }

  componentWillReceiveProps(newProps) {
    this.setState({
      language: window.language.setLanguage(newProps.match.params.lang)
        .components
    });
  }

  render() {
    const { classes } = this.props;
    const language = this.state.language;
    const aboutIntro =
      language.aboutus && language.aboutus.text
        ? language.aboutus.text.split(". ")[0]
        : language.desc;

    return (
      <Layout
        language={language}
        color="transparent"
        {...this.props}
      >
        <Parallax filter className="bgg-home-hero" image={require("../../assets/img/bg4.jpg")}>
          <div className={classes.container}>
            <GridContainer>
              <GridItem>
                <div className={`${classes.brand} bgg-hero-content`}>
                  <span className="bgg-hero-tagline">{language.desc}</span>
                  <h1 className={classes.title}>
                    {language.maintitle}
                  </h1>
                  <h3 className={classes.subtitle}>
                    {aboutIntro}
                  </h3>
                  <div className="bgg-hero-actions">
                    <button
                      type="button"
                      className="bgg-btn bgg-btn-primary bgg-btn-lg"
                      onClick={() => this.props.history.push(window.language.currUrl(this.props.match, "aboutus"))}
                    >
                      {language.about}
                    </button>
                    <button
                      type="button"
                      className="bgg-btn bgg-btn-glass bgg-btn-lg"
                      onClick={() => this.props.history.push(window.language.currUrl(this.props.match, "publications"))}
                    >
                      {language.publications}
                    </button>
                  </div>
                  <div className="bgg-hero-chips">
                    <span className="bgg-hero-chip">{language.projects}</span>
                    <span className="bgg-hero-chip">{language.trainings}</span>
                    <span className="bgg-hero-chip">{language.events}</span>
                  </div>
                </div>
              </GridItem>
            </GridContainer>
          </div>
        </Parallax>

        <div className={classNames(classes.main, classes.mainRaised)}>
          <SectionServices
            {...language.services}
            lang={language.lang}
          />
          <Flipp
            {...language}
            match={this.props.match}
            history={this.props.history}
          />
          <SectionSponsor {...language.partners} />
          <SectionProjects
            {...language.news}
            lang={language.lang}
          />
          <SectionContacts {...language.contact} />
        </div>
      </Layout>
    );
  }
}

export default withRouter(withStyles(componentsStyle)(Components));



// WEBPACK FOOTER //
// ./src/views/Components/Components.jsx